<script setup lang="ts">
  import { HLProgress } from '@platform-ui/highrise'

  defineProps({
    id: {
      type: String,
      required: true,
    },
  })
</script>

<template>
  <HLProgress :id="id" v-bind="$attrs" class="cp-progress">
    <slot />
  </HLProgress>
</template>

<!--
  Unscoped: HighRise progress rail defaults to a light gray that reads as a
  bright strip on dark course surfaces (quiz nav, lesson sidebar progress).
-->
<style>
  .cp-progress {
    --n-rail-color: var(--cp-border-600) !important;
    --n-fill-color: var(--cp-primary-500) !important;
    --n-icon-color: var(--cp-font-600) !important;
    --n-text-color: var(--cp-font-600) !important;
  }

  .cp-progress .hr-progress-graph-line-rail,
  .cp-progress .n-progress-graph-line-rail {
    background-color: var(--cp-border-600) !important;
  }

  .cp-progress .hr-progress-text,
  .cp-progress .n-progress-text,
  .cp-progress .hr-progress-text-container,
  .cp-progress .n-progress-text-container {
    color: var(--cp-font-600) !important;
    background-color: transparent !important;
  }
</style>
